import axios from 'axios';
import { Api } from './index';

export const fetchAdGemData = (adGemAppId, userId) =>
  axios.get(
    `https://api.adgem.com/v1/wall/json?playerid=${userId}&appid=${adGemAppId}&userid=${userId}`
  );

export const fetchActiveOfferIds = () => Api.get('/offers/adgem');
